/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OntologyNodeItemsRequest {
    getFixupPrototypeFunction() { return OntologyNodeItemsRequest.fixupPrototype; }

    static newInstance(model: Partial<OntologyNodeItemsRequest>): OntologyNodeItemsRequest {
        let obj = Object.assign(new OntologyNodeItemsRequest(), model);
        OntologyNodeItemsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OntologyNodeItemsRequest>): OntologyNodeItemsRequest {
        if (!model) return null;
        return OntologyNodeItemsRequest.newInstance(<OntologyNodeItemsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OntologyNodeItemsRequest) {
        if (!obj) return;

        models.OntologyNodeItemsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OntologyNodeItemsRequest): boolean {
        Object.setPrototypeOf(obj, OntologyNodeItemsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.offset === undefined) {
            this.offset = 0;
        }
        if (this.limit === undefined) {
            this.limit = 0;
        }
    }

    /**
     * Tenant the node belongs to
     */
    tenant_id: string;

    /**
     * Bucket node identifier to page items for
     */
    node_id: string;

    /**
     * Pagination offset
     */
    offset: number;

    /**
     * Page size
     */
    limit: number;

}
